import React, {useEffect, useContext} from 'react';
import {ViewDataContext} from '../../commons/context/view/ViewDataContext';
import PackageSearch from "./PackageSearch";
import {FiltersStateContext} from "../../commons/context/FiltersStateContext";
import {getDocumentURL, getFeaturesFromParent} from "../../handler/ParentDataHandler";
import { FiltersStateInitializer } from '../../commons/defaultInitializer/FiltersStateInitializer';
import {ACTION_TYPE, FEATURES} from "../../commons/constants/CommonConstants";
import {chainWalk} from "../../commons/CommonUtils";
import {FeatureConfigContext} from "../../commons/context/FeatureConfigContext";
 
export const PackageSearchData = (props) => {

    let search = window.location.search;
    let params = new URLSearchParams(search);
    let stationCode = params.get('stationCode');
   
    const {viewModel, dispatch} = useContext(ViewDataContext)
    const {configViewModel, configDispatch} = useContext(FeatureConfigContext)
    //Whenever filter value will change, it should re render
    const {selectedFilterValues} = useContext(FiltersStateContext)
    const filters = FiltersStateInitializer(selectedFilterValues);

    if ((selectedFilterValues.isApplyFilterClicked === true || selectedFilterValues.isApplyFilterClicked === undefined)
        //Check for either dwell start and end for Dwell /RTS or ageing tab
           && ((Number(filters.dwellStart) > Number(filters.dwellEnd)) ||  (filters.dwellStartTimeUnit !== filters.dwellEndTimeUnit))) {

        useEffect(() => {
            getFeaturesFromParent([FEATURES.IS_CPT_FILTER_ENABLED]).then(featureStatus => {
                configDispatch({type: ACTION_TYPE.GET_FEATURES_STATUS, featureStatus: featureStatus.data});
            })

            const isCPTFilterEnabled = chainWalk(() => configViewModel.featureStatus[FEATURES.IS_CPT_FILTER_ENABLED], false);
            getDocumentURL().then(result => {
                dispatch({type: "SET_BASE_URL", data:result});
            });
            dispatch({ type: 'LOAD_VIEW', data:{filters: selectedFilterValues , 
            stationCode, view : "PACKAGE_DRILLDOWN" ,prevView : viewModel.prevView, leg : selectedFilterValues.leg ? selectedFilterValues.leg.toUpperCase() : "FORWARD", dispatcher: dispatch, isCPTFilter: isCPTFilterEnabled}});
        }, [selectedFilterValues]);
 
        useEffect(() => {
            return () => dispatch({ type: 'UNLOAD_VIEW'});
        }, []);
    }

    return (
        <PackageSearch data = {viewModel.packageResultList} addressFieldsEnabled = {viewModel.addressFieldsEnabled} hazmatVisibilityEnabled = {viewModel.hazmatVisibilityEnabled} baseURL = {viewModel.baseURL} isLoading = {viewModel.isLoading} filters = {selectedFilterValues}
        stationCode = {stationCode} dispatcher={dispatch} history={props.history} location={props.location} buybackVisibilityEnabled={viewModel.buyBackVisibilityEnabled}/>
    )
}


// WEBPACK FOOTER //
// ./src/components/packageList/PackageSearchData.js